import React, { useMemo } from 'react';

import PledgeContextWorkflowContext, { DEFAULT_INITIAL_STATE } from './pledgeContextWorkflowContext';
import { PledgeContextWorkflowReducer } from './pledgeContextWorkflowReducer';

interface PledgeContextWorkflowConsumerProps {
    children: React.ReactNode;
}

export default function PledgeContextWorkflowConsumer(props: PledgeContextWorkflowConsumerProps) {
    const { children } = props;
    const [ pledgeContextWorkflowState, dispatchPledgeContextWorkflowAction ] = React.useReducer(
        PledgeContextWorkflowReducer,
        DEFAULT_INITIAL_STATE
    );

    const contexValues = useMemo(() => ({
        pledgeContextWorkflowState,
        dispatchPledgeContextWorkflowAction
    }
    ), [ pledgeContextWorkflowState, dispatchPledgeContextWorkflowAction ]);

    return (
        <PledgeContextWorkflowContext.Provider
            value={contexValues}
        >
            {children}
        </PledgeContextWorkflowContext.Provider>
    );
}